import React from 'react';
import styles from '../../styles/AdminPanel.module.scss';

const DeleteModal = ({ show, type, item, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.deleteModal}>
        <h3 className={styles.deleteModalTitle}>Підтвердження видалення</h3>
        <p className={styles.deleteModalText}>
          Ви впевнені, що хочете видалити {
            type === 'category' ? 'категорію' : 
            type === 'product' ? 'товар' : 
            type === 'user' ? 'користувача' : 
            type === 'order' ? 'замовлення' :
            type === 'poster' ? 'постер' :
            'елемент'
          } <strong>"{item?.name || item?.title || item?.heading || item?.email || (type === 'order' ? `№${item?.id}` : '')}"</strong>?
        </p>
        <div className={styles.deleteModalActions}>
          <button
            className={styles.cancelButton}
            onClick={onCancel}
          >
            Скасувати
          </button>
          <button
            className={styles.deleteConfirmButton}
            onClick={onConfirm}
          >
            Видалити
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;




